import { computed, makeObservable } from 'mobx';
import {observer} from 'mobx-react';
import React from 'react';
import {X9Content, X9ContentSnapshot} from '../../../../../../domain';
import {X9ContentStateStore} from '../../../common/X9ContentStateStore';
import {GapFillingModel} from '../../models';
import {StudentDndGapFilling} from './StudentDndGapFilling';
import {StudentKbtGapFilling} from './StudentKbtGapFilling';

interface Props {
  x9: X9Content | X9ContentSnapshot,
  store: X9ContentStateStore,
  lessonType?: string
}

@observer
export class StudentGapFilling extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
    makeObservable(this);
  }

  @computed
  get model(): GapFillingModel {
    return JSON.parse(this.props.x9.Contents) as GapFillingModel;
  }

  render() {
    const props = this.props;
    const model = this.model;
    const behavior = model.behavior;
    const id = this.props.x9.Id;

    if (behavior === 'drag-and-drop')
      return (<StudentDndGapFilling id={id} model={model} store={props.store} lessonType={props.lessonType}/>);

    if (behavior === 'keyboard-type')
      return (<StudentKbtGapFilling id={id} model={model} store={props.store} lessonType={props.lessonType}/>);

    return null;
  }
}
